import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { axiosSettings } from "../../axios/axios";
import { Port2State, Port2Params, Port2ApiResponse } from "./Port2Type";
import { RootState } from "../../redux/store";
import { GetTime } from "../../utils/timeget";

export const fetchAsyncPort2Info: any = createAsyncThunk<
  Port2ApiResponse,
  Port2Params
  //暫定的にPort1にデータを取得
>("port2/get", async () => {
  const response = await axiosSettings.get("api-admin/port2");
  return response.data;
});

const initialState: Port2State = {
  port2Status: null,
  updatedTime: "",
  loading: false,
  error: null,
};

const Port2InfoSlice = createSlice({
  name: "port2Info",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(fetchAsyncPort2Info.fulfilled, (state, action) => {
      if (action.payload.status === "Success") {
        state.port2Status = action.payload.data.result;
        state.updatedTime = GetTime();
        state.error = "";
      } else {
        state.error = action.payload.status;
        return;
      }
      state.loading = false;
    });
    builder.addCase(fetchAsyncPort2Info.pending, (state, action) => {
      state.loading = true;
    });
    builder.addCase(fetchAsyncPort2Info.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload.status;
    });
  },
});

export const Port2Status = (state: RootState) => state.Port2Info.port2Status;
export const Port2Error = (state: RootState) => state.Port2Info.error;
export const Port2Loading = (state: RootState) => state.Port2Info.loading;
export const Port2UpdatedTime = (state: RootState) =>
  state.Port2Info.updatedTime;
export default Port2InfoSlice.reducer;
